/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/activities-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/activities-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 * - Or run: npm run db:full-workflow (does everything)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/activities-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-activities-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/activities.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Generated at: 2026-09-19T18:30:21.780Z
 * Source config: config/entities/activities-entity-config.ts
 * Public fields: 49/49 total fields
 */

import { Type, Static } from '@sinclair/typebox';


// TypeBox schemas for runtime validation (public fields only)
export const ActivitiesSchema = Type.Object({
  id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // id field - primary key
  activity_type_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // activity_type_id field
  name: Type.Union([Type.String(), Type.Null()]), // name field
  description: Type.Union([Type.String(), Type.Null()]), // description field
  stage_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // stage_id field
  status_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // status_id field
  is_blocking: Type.Union([Type.Boolean(), Type.Null()]), // is_blocking field
  estimated_duration: Type.Union([Type.String(), Type.Null()]), // estimated_duration field
  actual_duration: Type.Union([Type.String(), Type.Null()]), // actual_duration field
  scheduled_date: Type.Union([Type.String(), Type.Null()]), // scheduled_date field
  completed_date: Type.Union([Type.String(), Type.Null()]), // completed_date field
  specifications: Type.Union([Type.String(), Type.Null()]), // specifications field
  priority: Type.Union([Type.Number(), Type.Null()]), // priority field
  verification_notes: Type.Union([Type.String(), Type.Null()]), // verification_notes field
  photo_ids: Type.Union([Type.String(), Type.Null()]), // photo_ids field
  signature_data: Type.Union([Type.String(), Type.Null()]), // signature_data field
  created_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // created_at field - auto-managed timestamp
  updated_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // updated_at field - auto-managed timestamp
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  start_date: Type.Union([Type.String(), Type.Null()]), // start_date field
  end_date: Type.Union([Type.String(), Type.Null()]), // end_date field
  trig_area_lot_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // trig_area_lot_id field - trigger-populated denormalized field
  trig_activity_type_name: Type.Union([Type.String(), Type.Null()]), // trig_activity_type_name field - trigger-populated denormalized field
  trig_activity_type_color: Type.Union([Type.String(), Type.Null()]), // trig_activity_type_color field - trigger-populated denormalized field
  trig_activity_status_name: Type.Union([Type.String(), Type.Null()]), // trig_activity_status_name field - trigger-populated denormalized field
  trig_activity_status_color: Type.Union([Type.String(), Type.Null()]), // trig_activity_status_color field - trigger-populated denormalized field
  trig_activity_stage_name: Type.Union([Type.String(), Type.Null()]), // trig_activity_stage_name field - trigger-populated denormalized field
  parent_activity_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // parent_activity_id field
  area_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // area_id field
  trig_area_stage_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // trig_area_stage_id field - trigger-populated denormalized field
  trig_lot_address: Type.Union([Type.String(), Type.Null()]), // trig_lot_address field - trigger-populated denormalized field
  trig_lot_number: Type.Union([Type.String(), Type.Null()]), // trig_lot_number field - trigger-populated denormalized field
  trig_builder_name: Type.Union([Type.String(), Type.Null()]), // trig_builder_name field - trigger-populated denormalized field
  trig_lot_phase_name: Type.Union([Type.String(), Type.Null()]), // trig_lot_phase_name field - trigger-populated denormalized field
  trig_job_name: Type.Union([Type.String(), Type.Null()]), // trig_job_name field - trigger-populated denormalized field
  city: Type.Union([Type.String(), Type.Null()]), // city field
  square_footage: Type.Union([Type.Number(), Type.Null()]), // square_footage field
  square_footage_claimed: Type.Union([Type.Boolean(), Type.Null()]), // square_footage_claimed field
  needs_follow_up: Type.Union([Type.Boolean(), Type.Null()]), // needs_follow_up field (F7) - flags an activity as needing manager follow-up. Composes with the Completed status; not a status. Reason stored in verification_notes.
  completed_by: Type.Union([Type.String(), Type.Null()]), // completed_by field
  department: Type.Union([Type.String(), Type.Null()]), // department field
  trig_category_name: Type.Union([Type.String(), Type.Null()]), // trig_category_name field - trigger-populated denormalized field
  updated_by: Type.Union([Type.String(), Type.Null()]), // updated_by field
  trig_organization_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // trig_organization_id field - trigger-populated denormalized field
  trig_assigned_users: Type.Union([Type.String(), Type.Null()]), // trig_assigned_users field - trigger-populated denormalized field
  was_autocompleted: Type.Union([Type.Boolean(), Type.Null()]), // was_autocompleted field
  procedure_link: Type.Union([Type.String(), Type.Null()]), // procedure_link field
  photo_required: Type.Union([Type.Boolean(), Type.Null()]), // photo_required field - per-instance OVERRIDE of the activity type requires_photo default. NULL = inherit activity_type.requires_photo.
  trig_effective_photo_required: Type.Union([Type.Boolean(), Type.Null()]), // trig_effective_photo_required field - denormalized resolved flag: COALESCE(photo_required, activity_type.requires_photo, false). Read by the field app; enforced by card B3.
});

export const CreateActivitiesSchema = Type.Object({
  activity_type_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // activity_type_id field
  name: Type.Union([Type.String(), Type.Null()]), // name field
  description: Type.Union([Type.String(), Type.Null()]), // description field
  stage_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // stage_id field
  status_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // status_id field
  is_blocking: Type.Union([Type.Boolean(), Type.Null()]), // is_blocking field
  estimated_duration: Type.Union([Type.String(), Type.Null()]), // estimated_duration field
  actual_duration: Type.Union([Type.String(), Type.Null()]), // actual_duration field
  scheduled_date: Type.Union([Type.String(), Type.Null()]), // scheduled_date field
  completed_date: Type.Union([Type.String(), Type.Null()]), // completed_date field
  specifications: Type.Union([Type.String(), Type.Null()]), // specifications field
  priority: Type.Union([Type.Number(), Type.Null()]), // priority field
  verification_notes: Type.Union([Type.String(), Type.Null()]), // verification_notes field
  photo_ids: Type.Union([Type.String(), Type.Null()]), // photo_ids field
  signature_data: Type.Union([Type.String(), Type.Null()]), // signature_data field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  start_date: Type.Union([Type.String(), Type.Null()]), // start_date field
  end_date: Type.Union([Type.String(), Type.Null()]), // end_date field
  parent_activity_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // parent_activity_id field
  area_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // area_id field
  square_footage: Type.Union([Type.Number(), Type.Null()]), // square_footage field
  square_footage_claimed: Type.Union([Type.Boolean(), Type.Null()]), // square_footage_claimed field
  needs_follow_up: Type.Union([Type.Boolean(), Type.Null()]), // needs_follow_up field (F7) - flags an activity as needing manager follow-up. Composes with the Completed status; not a status. Reason stored in verification_notes.
  completed_by: Type.Union([Type.String(), Type.Null()]), // completed_by field
  department: Type.Union([Type.String(), Type.Null()]), // department field
  updated_by: Type.Union([Type.String(), Type.Null()]), // updated_by field
  was_autocompleted: Type.Union([Type.Boolean(), Type.Null()]), // was_autocompleted field
  procedure_link: Type.Union([Type.String(), Type.Null()]), // procedure_link field
  photo_required: Type.Union([Type.Boolean(), Type.Null()]), // photo_required field - per-instance OVERRIDE of the activity type requires_photo default. NULL = inherit activity_type.requires_photo.
});

export const UpdateActivitiesSchema = Type.Object({
  activity_type_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // activity_type_id field
  name: Type.Union([Type.String(), Type.Null()]), // name field
  description: Type.Union([Type.String(), Type.Null()]), // description field
  stage_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // stage_id field
  status_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // status_id field
  is_blocking: Type.Union([Type.Boolean(), Type.Null()]), // is_blocking field
  estimated_duration: Type.Union([Type.String(), Type.Null()]), // estimated_duration field
  actual_duration: Type.Union([Type.String(), Type.Null()]), // actual_duration field
  scheduled_date: Type.Union([Type.String(), Type.Null()]), // scheduled_date field
  completed_date: Type.Union([Type.String(), Type.Null()]), // completed_date field
  specifications: Type.Union([Type.String(), Type.Null()]), // specifications field
  priority: Type.Union([Type.Number(), Type.Null()]), // priority field
  verification_notes: Type.Union([Type.String(), Type.Null()]), // verification_notes field
  photo_ids: Type.Union([Type.String(), Type.Null()]), // photo_ids field
  signature_data: Type.Union([Type.String(), Type.Null()]), // signature_data field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  start_date: Type.Union([Type.String(), Type.Null()]), // start_date field
  end_date: Type.Union([Type.String(), Type.Null()]), // end_date field
  parent_activity_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // parent_activity_id field
  area_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // area_id field
  square_footage: Type.Union([Type.Number(), Type.Null()]), // square_footage field
  square_footage_claimed: Type.Union([Type.Boolean(), Type.Null()]), // square_footage_claimed field
  needs_follow_up: Type.Union([Type.Boolean(), Type.Null()]), // needs_follow_up field (F7) - flags an activity as needing manager follow-up. Composes with the Completed status; not a status. Reason stored in verification_notes.
  completed_by: Type.Union([Type.String(), Type.Null()]), // completed_by field
  department: Type.Union([Type.String(), Type.Null()]), // department field
  updated_by: Type.Union([Type.String(), Type.Null()]), // updated_by field
  was_autocompleted: Type.Union([Type.Boolean(), Type.Null()]), // was_autocompleted field
  procedure_link: Type.Union([Type.String(), Type.Null()]), // procedure_link field
  photo_required: Type.Union([Type.Boolean(), Type.Null()]), // photo_required field - per-instance OVERRIDE of the activity type requires_photo default. NULL = inherit activity_type.requires_photo.
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type ActivitiesRow = Static<typeof ActivitiesSchema>;
export type ActivitiesInsert = Static<typeof CreateActivitiesSchema>;
export type ActivitiesUpdate = Static<typeof UpdateActivitiesSchema>;

// Legacy type aliases for backward compatibility
export type Activities = ActivitiesRow;
export type CreateActivities = ActivitiesInsert;
export type UpdateActivities = Static<typeof UpdateActivitiesSchema>;

// Field configuration metadata
export const ActivitiesFieldConfig = {
  filterable: ['id', 'activity_type_id', 'stage_id', 'status_id', 'is_blocking', 'trig_area_lot_id', 'parent_activity_id', 'area_id', 'trig_area_stage_id', 'needs_follow_up', 'trig_organization_id', 'photo_required', 'trig_effective_photo_required'] as const,
  sortable: ['created_at', 'updated_at'] as const,
  searchable: [] as const,
  required: [] as const,
  readonly: ['id', 'created_at', 'updated_at', 'trig_area_lot_id', 'trig_activity_type_name', 'trig_activity_type_color', 'trig_activity_status_name', 'trig_activity_status_color', 'trig_activity_stage_name', 'trig_area_stage_id', 'trig_lot_address', 'trig_lot_number', 'trig_builder_name', 'trig_lot_phase_name', 'trig_job_name', 'city', 'trig_category_name', 'trig_organization_id', 'trig_assigned_users', 'trig_effective_photo_required'] as const,
} as const;

// Query options interface for API operations
import type { UnifiedQueryOptions } from '../../../config/search/global-search-config.js';

export interface ActivitiesQueryOptions extends UnifiedQueryOptions {}

// Response types for API operations
export interface ActivitiesResponse {
  data: Activities[] | null;
  error: Error | null;
  count?: number;
}

export interface SingleActivitiesResponse {
  data: Activities | null;
  error: Error | null;
}
